import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './components/ui';
import './i18n';
import { ApiError } from './lib/api';
import { AuthProvider, startLoginEarly } from './lib/auth';
import { startEarlyPrefetch } from './lib/early-start';
import { installGlobalErrorHandlers } from './lib/error-reporter';
import { applyTheme, initTelegram } from './lib/telegram';
import './styles.css';

installGlobalErrorHandlers();
initTelegram();
applyTheme();

// Вход и данные первого экрана запрашиваются сразу, параллельно с отрисовкой (см. lib/early-start.ts).
startLoginEarly();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Не повторяем ошибки клиента (404, 403 и т. п.) — только сетевые/серверные, не более 2 раз.
      retry: (count, error) => count < 2 && (!(error instanceof ApiError) || error.status === 0 || error.status >= 500),
      refetchOnWindowFocus: false,
    },
  },
});

startEarlyPrefetch(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
